module.exports = __webpack_public_path__ + "media/images/emblems/Feldbrunnen-StNiklaus-blason-eb07b99f06e108b685ce732bbf989737.png";